import React from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Link,
  Grid,
  Chip,
  Stack,
} from "@mui/material";
import Navbar from "../components/Navbar";
import blogPosts from "../data/blogPosts";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const posts = Object.keys(blogPosts).map((slug) => ({
  slug,
  ...blogPosts[slug],
}));

export default function BlogPage() {
  return (
    <>
      <Navbar />
      {/* Subtle background gradient and pattern */}
      <Box
        sx={{
          background: "linear-gradient(120deg,#f5f7fa 0%,#e9f0fd 100%)",
          minHeight: "100vh",
          py: { xs: 6, md: 10 },
        }}
      >
        <Container maxWidth="md">
          {/* HERO */}
          <Box
            sx={{
              textAlign: "center",
              mb: 8,
              px: { xs: 1, md: 4 },
            }}
          >
            {/* Replace below with your own SVG/illustration if you want */}
            <Typography
              variant="overline"
              color="primary"
              fontWeight={700}
              sx={{ letterSpacing: 1.5 }}
            >
              SortlyBooks Blog
            </Typography>
            <Typography
              variant="h2"
              fontWeight={800}
              sx={{ mt: 1, mb: 2, fontSize: { xs: "2rem", md: "2.7rem" } }}
            >
              Blog & Resources
            </Typography>
            <Typography
              variant="h6"
              color="text.secondary"
              sx={{ maxWidth: 520, mx: "auto", mb: 1.5 }}
            >
              Tips, guides, and product updates for freelancers & small
              businesses to level up their finances, save time, and stay
              stress-free at tax time.
            </Typography>
          </Box>
          {/* POSTS GRID */}
          <Grid container spacing={4}>
            {posts.map((post, i) => (
              <Grid
                item
                xs={12}
                sm={6}
                key={post.slug}
                sx={{
                  display: "flex",
                  alignItems: "stretch",
                }}
              >
                <Paper
                  component={Link}
                  href={`/blog/${post.slug}`}
                  elevation={0}
                  underline="none"
                  sx={{
                    flex: 1,
                    background: "white",
                    p: 4,
                    borderRadius: "2rem",
                    minHeight: 260,
                    boxShadow:
                      "0 4px 24px 0 rgba(30,32,78,0.06), 0 1.5px 6px 0 rgba(110,125,245,0.06)",
                    border: "1.5px solid #ecf1fa",
                    transition: "all 0.18s cubic-bezier(.4,0,.2,1)",
                    textDecoration: "none",
                    color: "inherit",
                    position: "relative",
                    "&:hover": {
                      boxShadow:
                        "0 8px 32px 0 rgba(30,32,78,0.13), 0 2.5px 12px 0 rgba(110,125,245,0.09)",
                      borderColor: "#d2e3fa",
                      transform: "translateY(-2px) scale(1.018)",
                    },
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Stack direction="row" spacing={1} mb={2}>
                    <Chip
                      label={new Date(post.date).toLocaleDateString(undefined, {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                      color="primary"
                      variant="outlined"
                      size="small"
                    />
                    {/* Optional: Add tag chips here if you add tags to posts */}
                  </Stack>
                  <Typography
                    variant="h5"
                    fontWeight={800}
                    sx={{ mb: 1, minHeight: 54 }}
                  >
                    {post.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{
                      mb: 2,
                      minHeight: 56,
                      lineHeight: 1.5,
                    }}
                  >
                    {post.desc ||
                      (post.content
                        ? post.content.slice(0, 130).replace(/\n/g, " ") + "..."
                        : "")}
                  </Typography>
                  <Box sx={{ flexGrow: 1 }} />
                  <Box
                    sx={{
                      textAlign: "right",
                      mt: 2,
                    }}
                  >
                    <ArrowForwardIcon
                      sx={{
                        color: "primary.main",
                        verticalAlign: "middle",
                        fontSize: 32,
                        transition: "all 0.2s",
                        "&:hover": { color: "secondary.main" },
                      }}
                    />
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
}
